import { marketingColors as C, marketingFonts as F, visualTokens as V } from '../../theme_landing_page_2';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box } from '@mui/material';
import { MillosMark, MillosWordmark } from './icons';

const columns = [
  {
    title: 'Product',
    links: [
      { label: 'Certificates', to: '/compliance-centre' },
      { label: 'Accounting', to: '/accounting-centre' },
      { label: 'Pricing', to: '/pricing' },
    ],
  },
  {
    title: 'Resources',
    links: [
      { label: 'Blog & guides', to: '/resources' },
      { label: 'Free tools', to: '/calculators' },
    ],
  },
  {
    title: 'Contact',
    links: [
      { label: 'Book a demo', to: '/book-a-call' },
      { label: 'Help / FAQ', to: '/help' },
    ],
  },
];

const linkSx = {
  color: C.body, fontSize: V.fontSize14, textDecoration: 'none',
  '&:hover': { color: C.ink, textDecoration: 'underline' },
  '&:focus-visible': { outline: `2px solid ${C.ink}`, outlineOffset: 4 },
};

const MarketingFooter: React.FC = () => (
  <Box component="footer" className="lv-marketing" sx={{
    padding: { xs: '32px 24px 24px', md: '48px 52px 24px' },
    fontFamily: F.body, background: C.white, borderTop: `1px solid ${C.hairline}`,
  }}>
    <Box sx={{ maxWidth: 1000, mx: 'auto' }}>
      <Box sx={{
        display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1.5fr 1fr 1fr 1fr' },
        gap: { xs: '20px', md: '40px' },
      }}>
        <Box>
          <Box component={RouterLink} to="/" aria-label="MillOS home" sx={{ display: 'inline-flex', alignItems: 'center', gap: '10px' }}>
            <MillosMark size={32} />
            <MillosWordmark fontSize="1.375rem" />
          </Box>
          <Box component="p" sx={{ fontSize: V.fontSize14, color: C.body, mt: 1, mb: 0 }}>
            Property admin, handled by AI.
          </Box>
        </Box>
        {columns.map((column) => (
          <Box key={column.title}>
            <Box sx={{ display: { xs: 'none', md: 'block' } }}>
              <Box component="h3" sx={{ m: 0, mb: 2, fontSize: V.fontSize14, fontWeight: 600, color: C.ink }}>{column.title}</Box>
              <Box component="nav" aria-label={`${column.title} footer links`} sx={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                {column.links.map((link) => <Box component={RouterLink} key={link.to} to={link.to} sx={linkSx}>{link.label}</Box>)}
              </Box>
            </Box>
            <Box component="details" sx={{
              display: { xs: 'block', md: 'none' }, borderBottom: `1px solid ${C.hairline}`,
              '& summary': { cursor: 'pointer', py: '10px', fontSize: V.fontSize14, fontWeight: 600, color: C.ink },
            }}>
              <Box component="summary">{column.title}</Box>
              <Box component="nav" aria-label={`${column.title} footer links`} sx={{ display: 'flex', flexDirection: 'column', gap: '12px', pb: 2, pt: 1 }}>
                {column.links.map((link) => <Box component={RouterLink} key={link.to} to={link.to} sx={linkSx}>{link.label}</Box>)}
              </Box>
            </Box>
          </Box>
        ))}
      </Box>
      <Box sx={{
        mt: { xs: 3, md: 4 }, pt: 2, borderTop: `1px solid ${C.hairline}`,
        display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '12px',
      }}>
        <Box sx={{ fontSize: V.fontSize13, color: C.muted }}>© {new Date().getFullYear()} MillOS</Box>
        <Box component="nav" aria-label="Footer legal and sign in" sx={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
          {[{ label: 'Privacy', to: '/privacy' }, { label: 'Cookies', to: '/cookies' }, { label: 'Sign in', to: '/login' }].map((link) => (
            <Box component={RouterLink} key={link.to} to={link.to} sx={{ ...linkSx, fontSize: V.fontSize13 }}>{link.label}</Box>
          ))}
        </Box>
      </Box>
    </Box>
  </Box>
);

export default MarketingFooter;
